import * as React from 'react';
// @ts-ignore
import { ReactComponent as NeveLogoSVG } from '../assets/icons/neve-learning-icons/neve-learning-logo-main.svg';
import strings from '../strings/strings.json';

export default function NeveLogo(): JSX.Element {
    return <NeveLogoSVG id="neveLogo" role="img" alt={strings.appHeader.neveLearningLogoAltText} />;
}
